import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Printer, ArrowLeft, Layers } from "lucide-react";
import { CASE_STUDIES } from "@/data/portfolio";
import { track } from "@/lib/analytics";
import OnePager from "@/components/site/OnePager";

export default function CaseStudyPrint() {
  const { slug } = useParams();
  const cs = CASE_STUDIES.find((c) => c.slug === slug);

  useEffect(() => {
    if (cs) document.title = `${cs.title}, one-pager, Sinthu Nathan`;
  }, [cs]);

  if (!cs) {
    return (
      <div className="p-10">
        <Link to="/" className="underline">Back home</Link>
      </div>
    );
  }

  return (
    <div data-testid="print-page" className="min-h-screen bg-[#e9e4dc] print:bg-white py-8 print:py-0">
      <div className="no-print max-w-[210mm] mx-auto mb-4 flex items-center justify-between gap-3 px-2 flex-wrap">
        <Link
          to={`/case-studies/${cs.slug}`}
          data-testid="print-back"
          className="inline-flex items-center gap-2 text-sm text-[#55625b] hover:text-[#9a7218]"
        >
          <ArrowLeft className="h-4 w-4" /> Full case study
        </Link>
        <div className="flex items-center gap-2">
          <Link
            to="/portfolio-pdf"
            data-testid="print-bundle-link"
            className="inline-flex items-center gap-2 h-10 px-4 rounded-full border border-[#14352a] text-sm font-medium hover:bg-[#14352a] hover:text-white transition-colors"
          >
            <Layers className="h-4 w-4" /> Full 5-page PDF
          </Link>
          <button
            data-testid="print-download-btn"
            onClick={() => {
              track("print_download", { slug: cs.slug }, `/case-studies/${cs.slug}`);
              window.print();
            }}
            className="inline-flex items-center gap-2 h-10 px-5 rounded-full btn-guide text-sm font-medium"
          >
            <Printer className="h-4 w-4" /> Save as PDF
          </button>
        </div>
      </div>
      <OnePager cs={cs} />
    </div>
  );
}
